import { useEffect } from 'react';
import { useHaltPropagation } from  '@/components/hooks/utility/useHaltPropagation';



interface IUseDeleteCommentProps {
    showModal?: boolean, 
    onCloseClick: (() => void),
    onConfirmClick: (() => void),
}

const UseDeleteComment = ({showModal, onCloseClick, onConfirmClick}: IUseDeleteCommentProps) => {
    const modalIsOpen = showModal

    const handleCancelClick = (e: React.MouseEvent) => {
        useHaltPropagation(e);
        onCloseClick();
    };

    const handleConfirmClick = (e: React.MouseEvent) => {
        useHaltPropagation(e);
        onConfirmClick();
    };

    useEffect(() => {
        if(modalIsOpen) {
            document.body.classList.add('delete-comment-modal-is-open')
        } else {
            document.body.classList.remove('delete-comment-modal-is-open')
        }
    }, [modalIsOpen])

    return {
        handleCancelClick, handleConfirmClick
    }
};
export default UseDeleteComment


export const DeleteCommentConstants = {
    title : "Delete Comment",
    deleteQuestion : "Are you sure you want to permanently delete this comment?",
    cancelButtonText : "Cancel",
    cancelButtonAriaLabel : "Cancel and do not delete the comment",
    confirmButtonText : "Confirm",
    confirmButtonAriaLabel : "Confirm and delete the comment",
    deleteCommentButtonText: "Delete Comment",
    deleteCommentButtonLabel : "Delete the flagged comment",
    deleteCommentButtonClassname : "delete-comment-button" 
}